import { Component, Input, input, output, Signal } from '@angular/core';
import {
  TreeRemovalReasonAppEntityDictionaryTreeRemovalReason,
  TreeToRemoveAppEntityTreeToRemoveWrite
} from '../../../../../../../../openapi';
import { AlertComponent } from '../../../../../../../../common/alert/alert.component';
import { LabelComponent } from '../../../../../../../../common/label/label.component';
import { CommonModule } from '@angular/common';
import { TreeRemovalReasonPipe } from '../../../../../../../../pipes/tree-to-remove/tree-removal-reason.pipe';
import { Store } from '@ngrx/store';
import { selectTreeRemovalReasons } from '../../../../../../../../store/selectors/application.selectors';
import { AccordionGroupComponent } from "../../../../../../../../common/accordion-group/accordion-group.component";
import { AccordionItemComponent } from "../../../../../../../../common/accordion-item/accordion-item.component";
import {
  TreeToRemoveTrunkCircumference130LabelPipe
} from "../../../../../../../../pipes/tree-to-remove/tree-to-remove-trunkCircumference130-label.pipe";
import { CapitalizeFirstLetterPipe } from "../../../../../../../../pipes/capitalize-first-letter.pipe";

@Component({
  selector: 'app-trees-to-remove-preview',
  standalone: true,
  imports: [
    AlertComponent,
    LabelComponent,
    CommonModule,
    TreeRemovalReasonPipe,
    AccordionGroupComponent,
    AccordionItemComponent,
    TreeToRemoveTrunkCircumference130LabelPipe,
    CapitalizeFirstLetterPipe
  ],
  templateUrl: './trees-to-remove-preview.component.html'
})
export class TreesToRemovePreviewComponent {

  @Input()
  public expanded: boolean = true;

  public treesToRemove = input<TreeToRemoveAppEntityTreeToRemoveWrite[]>([]);

  public showActions = input(false);

  public canEdit = input(true);

  public onEdit = output<{ v: TreeToRemoveAppEntityTreeToRemoveWrite; i: number }>();

  public onRemove = output<number>();

  public reasons: Signal<TreeRemovalReasonAppEntityDictionaryTreeRemovalReason[]> = this.store$.selectSignal(selectTreeRemovalReasons)

  constructor(private store$: Store) {
  }

}
